import script from "./ActivitiesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__